import {createFeatureSelector, createSelector} from "@ngrx/store";
import {ISharedLoginStoreState} from "./shared-login.state";
import {ResourceProfileFeatureDto} from "@server-models";

export const sharedLoginSelect = createFeatureSelector<ISharedLoginStoreState>('sharedLogin');

export const selectLoginState = createSelector(
  sharedLoginSelect, (state: ISharedLoginStoreState) => state
);

export const selectCanUseApp = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.canUseApp
);

export const selectIsGuest = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.isGuest
);

export const selectIsLoading = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.isLoading
);

export const selectToken = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentToken
);

export const selectUser = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentUser
);

export const selectTenant = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentTenant
);

export const selectBrand = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentBrand
);

export const selectAppSettings = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentSettings
);

export const selectAppType = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentApp
);

export const selectAppSegment = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentAppSegment
);

export const selectClient = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentClient
);

export const selectRefreshToken = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.currentToken?.refreshToken
);

export const selectIsMultiTenant = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.isMultiTenant
);

export const selectEmail = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.tempEmail
);

export const selectPassword = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.tempPassword
);

export const selectLinkFeatures = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.quickAccessProfile?.features
);

export const selectHasLinkFeature = (featureFn: (f: ResourceProfileFeatureDto) => boolean | undefined) => createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => !!state.quickAccessProfile?.features ? featureFn(state.quickAccessProfile.features) ?? false : false,
)

export const selectLinkResource = createSelector(
  sharedLoginSelect,
  (state: ISharedLoginStoreState) => state.quickAccessProfile?.resource
);
